module.exports = __webpack_public_path__ + "img/open-icon.4225f4bf.svg";